import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentDots } from "@fortawesome/free-solid-svg-icons";
import { useRef, useState } from 'react';
import { getToken } from '../../../function/token';
import domain from '../../../../reusecomponent/domain';
import { ErrorToastContainer } from '../../../function/CustomFunction';

function Startnewchat({ tabFunction, customers }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const mobileRef = useRef('');

  const onSubmit = (e) => {
    e.preventDefault();
    const exists = customers.current.data.some(item => item.wa_id === mobileRef.current);

    if (exists) {
      ErrorToastContainer("Chat already exists with this number");
      return;
    }

    setIsSubmitting(true);
    const token = getToken();
    const myHeaders = new Headers({ Authorization: `Bearer ${token}` });
    const formdata = new FormData();
    formdata.append("number", mobileRef.current);

    fetch(`${domain()}/startnewchat`, { method: "POST", headers: myHeaders, body: formdata, redirect: "follow" })
      .then(r => r.json())
      .then(result => {
        if (result.status) {
          mobileRef.current = '';
          let data = result.data;
          data.name = 'NC';
          data.last_update_time = data.updated_at;
          customers.current.data.unshift(result.data);
          tabFunction();
          setShowModal(false);
        } else {
          ErrorToastContainer(result.message);
        }
      })
      .catch(() => {
        mobileRef.current = '';
        ErrorToastContainer("Internal Server Error");
      })
      .finally(() => setIsSubmitting(false));
  };

  return (
    <>
      <button
        disabled
        title="New chat is disabled"
        className="btn btn-sm d-flex align-items-center gap-2"
        aria-label="New chat disabled"
        style={{
          backgroundColor: "#cbd5e1",
          color: "#64748b",
          border: "none",
          borderRadius: "20px",
          padding: "8px 14px",
          fontSize: "0.875rem",
          fontWeight: "600",
          cursor: "not-allowed",
          opacity: 0.7,
        }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        New Chat
      </button>

      {showModal && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", backdropFilter: "blur(8px)", zIndex: 1050 }}
          onClick={() => setShowModal(false)}
          role="dialog"
          aria-modal="true"
          aria-labelledby="newchat-modal-title"
        >
          <div
            className="bg-white rounded-4 shadow-lg"
            style={{ width: "90%", maxWidth: "500px", maxHeight: "90vh", overflow: "auto" }}
            onClick={e => e.stopPropagation()}
          >
            {/* Header */}
            <div
              className="d-flex justify-content-between align-items-center p-4 border-bottom"
              style={{ background: "linear-gradient(135deg, #075E54 0%, #128C7E 100%)", borderRadius: "16px 16px 0 0" }}
            >
              <h5 id="newchat-modal-title" className="mb-0 fw-bold text-white d-flex align-items-center gap-2">
                <FontAwesomeIcon icon={faCommentDots} />
                Start New Chat
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              />
            </div>

            {/* Body */}
            <div className="p-4">
              <form onSubmit={onSubmit}>
                <div className="mb-3">
                  <label className="form-label fw-semibold" htmlFor="newchat-phone">
                    Mobile Number <span className="text-danger">*</span>
                  </label>
                  <PhoneInput
                    country="in"
                    value={mobileRef.current}
                    onChange={(val) => (mobileRef.current = val)}
                    inputProps={{ id: 'newchat-phone', name: 'number', required: true }}
                    inputStyle={{
                      width: '100%',
                      border: '2px solid #E4E6EB',
                      borderRadius: '12px',
                      fontSize: '0.95rem',
                      height: '48px',
                      background: '#fff',
                      boxShadow: 'none',
                    }}
                    buttonStyle={{
                      border: '2px solid #E4E6EB',
                      borderRadius: '12px 0 0 12px',
                      background: '#fff',
                      height: '48px',
                    }}
                    containerStyle={{ width: '100%' }}
                    dropdownStyle={{ borderRadius: '12px', fontSize: '0.95rem' }}
                    enableSearch
                  />
                </div>

                {/* Footer */}
                <div className="d-flex gap-3 mt-4 pt-3 border-top">
                  <button
                    type="button"
                    onClick={() => setShowModal(false)}
                    className="btn flex-grow-1"
                    style={{
                      backgroundColor: "#F0F2F5",
                      color: "#111B21",
                      border: "none",
                      borderRadius: "12px",
                      padding: "12px 24px",
                      fontWeight: "600",
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="btn flex-grow-1 d-flex align-items-center justify-content-center gap-2"
                    style={{
                      backgroundColor: "#075E54",
                      color: "white",
                      border: "none",
                      borderRadius: "12px",
                      padding: "12px 24px",
                      fontWeight: "600",
                      boxShadow: "0 2px 8px rgba(7,94,84,0.3)",
                    }}
                  >
                    {isSubmitting ? (
                      <>
                        <div className="spinner-border spinner-border-sm" role="status">
                          <span className="visually-hidden">Loading…</span>
                        </div>
                        Starting…
                      </>
                    ) : (
                      "Start New Chat"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Startnewchat;